// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flag-component {
  position: relative;
  display: inline-block;
  width: 30px;
  border-radius: 5px;
  overflow: hidden;
  height: 22.5px;
}
.flag-component .flag-item {
  width: 100%;
  padding-top: 75%;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
}`, "",{"version":3,"sources":["webpack://./src/components/Flag/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AACF;AACE;EACE,WAAA;EACA,gBAAA;EACA,wBAAA;EACA,4BAAA;EACA,sBAAA;AACJ","sourcesContent":[".flag-component {\n  position: relative;\n  display: inline-block;\n  width: 30px;\n  border-radius: 5px;\n  overflow: hidden;\n  height: 22.5px;\n\n  .flag-item {\n    width: 100%;\n    padding-top: 75%;\n    background-position: 50%;\n    background-repeat: no-repeat;\n    background-size: cover;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
